import { marketList } from "#/config/markets";
import {
  type MarginAccountStatePairsType,
  type Market,
  type MarketPair,
  PortfolioSymbol,
  type PortfolioSymbolType,
  type UnderlyingSymbol,
} from "#/types/markets";

const VALID_UNDERLYING_SYMBOLS = Object.values(PortfolioSymbol).filter(
  (s) => s !== PortfolioSymbol.USDC,
) as string[];

export const validateUnderlyingSymbol = (
  symbol: string,
): symbol is UnderlyingSymbol => {
  return VALID_UNDERLYING_SYMBOLS.includes(symbol);
};

export const createMarketPairFromUnderlying = (
  underlying: UnderlyingSymbol,
): MarketPair => {
  return `${underlying}_USDC` as MarketPair;
};

export const getUnderlyingSymbolFromMarketPair = (
  marketPair: MarketPair,
): UnderlyingSymbol => marketPair.replace("_USDC", "") as UnderlyingSymbol;

export const getPortfolioSymbolFromPair = (
  pair: MarginAccountStatePairsType,
): PortfolioSymbolType => pair.split("_")[0] as PortfolioSymbolType;

export const getMarketByUnderlying = (underlying: UnderlyingSymbol): Market =>
  marketList.find((m) => m.underlying === underlying)!;
